<mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="formGroup">
  <mat-card-header>
    <mat-card-title>Personal Income details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="employmentFormArray?.controls && employmentFormArray?.controls.length > 0">
      <ng-container *ngFor="let brwEmployment of employmentFormArray?.controls; let brwIndex = index;">
        <div class="row">
          <div class="col-sm-12">
            <hr/>
            <h4>{{personList.getRawValue()[brwIndex]?.firstName}} {{personList.getRawValue()[brwIndex]?.lastName}}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <!-- <h5>Employments</h5> -->
          </div>
          <div class="col-4  text-end">
            <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addEmployment(brwEmployment, brwIndex)">Add Current Employment</button>
          </div>
        </div>

        <ng-container *ngFor="let employment of brwEmployment.get('currentEmployments')?.controls; let i = index; let first = first;">
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="row" *ngIf="first">
                <div class="col-12">
                  <h5>Current Employment</h5>
                </div>
              </div>
              <div class="row" [formGroup]="employment">
                <div class="col-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Employer</mat-label>
                    <input matInput placeholder="Employer" formControlName="employer" [readonly]="!employment.get('parent').value">
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Occupation</mat-label>
                    <input matInput placeholder="Occupation" formControlName="occupation">
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a category</mat-label>
                    <mat-select placeholder="Select a category" formControlName="category" (selectionChange)="checkEmployerValidation($event.value, employment)" [disabled]="!employment.get('parent').value">
                      <mat-option *ngFor="let type of employmentCategoryVxTypes" [value]="type.id">{{type.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-1 text-end">
                  <button type="button" *ngIf="!first" mat-icon-button (click)="removeEmployment(i, brwEmployment.get('currentEmployments')); " color="warn"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
              <div class="row" [formGroup]="employment">
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a status</mat-label>
                    <mat-select placeholder="Select a status" formControlName="status" (selectionChange)="handleEmploymentStatusChange(employment, $event.value)" [disabled]="!employment.get('parent').value">
                      <mat-option *ngFor="let status of employmentStatusTypes" [value]="status.id">{{status.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Basis</mat-label>
                    <mat-select placeholder="Basis" formControlName="basis" [disabled]="!employment.get('parent').value">
                      <mat-option
                        [disabled]="(employment.value.validBasis && !employment.value.validBasis.includes(status.id))"
                        *ngFor="let status of employmentTypes" [value]="status.id">{{status.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Tenure (years)</mat-label>
                    <input matInput placeholder="Tenure (years)" type="number" formControlName="lengthYears" (change)="togglePrevEmployer(brwEmployment.get('currentEmployments'), brwEmployment.get('previousEmployments')); toggleProbation($event.target.value, employment.get('probation'))">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Tenure (months)</mat-label>
                    <input matInput placeholder="Tenure (months)" type="number" min="0" max="11" formControlName="lengthMonths" (change)="togglePrevEmployer(brwEmployment.get('currentEmployments'), brwEmployment.get('previousEmployments'))">
                    <mat-error>Please input a number between 0 and 11</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-4" *ngIf="brwIndex === 0 && !isDisableAnzsic && personList.value[brwIndex].borrowerGuarantor === 'borrower'">
                  <mat-form-field appearance="outline" class="anzsic" [hidden]="!isInternalUser">
                    <mat-label>ANZSIC Category</mat-label>
                    <mat-select placeholder="ANZSIC category" formControlName="anzsicCategory">
                      <mat-option *ngFor="let type of anzsicCategories" [value]="type.id">
                        {{type.text}}
                      </mat-option>
                    </mat-select>
                    <button type="button" matSuffix mat-icon-button style="cursor: default" matTooltip="The industry the employer is in">
                      <mat-icon>info</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <div class="col-2 d-flex align-items-center">
                  <mat-checkbox  *ngIf="employment.value.lengthYears === 0" formControlName="probation" [value]="true"> Probation</mat-checkbox>
                </div>
              </div>

              <ng-container *ngIf="!isSMSF && employment && employment.get('status').value === 'self-employed' && employment.get('basis').value === 'self-employed'">
                <div class="row" [formGroup]="employment">
                  <div class="col-4">
                    <fmc-abn-search
                      *ngIf="employment.get('parent').value"
                      [parentFormGroup]="employment"
                      [controlName]="'abnAcnNumber'"
                      [placeholderText]="'ABN / ACN search'"
                      (abnResults)="selectAbnRecord($event, employment)"
                    ></fmc-abn-search>

                    <mat-form-field appearance="outline" *ngIf="!employment.get('parent').value">
                      <mat-label>ABN / ACN Search</mat-label>
                      <input matInput formControlName="abnAcnNumber" placeholder="ABN / ACN search" [readonly]="!employment.get('parent').value">
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <h5>Business Income</h5>
                  </div>
                </div>
                <div class="row" [formGroup]="employment">
                  <div class="col-4">
                    <mat-form-field appearance="outline">
                      <mat-label>Business type</mat-label>
                      <mat-select placeholder="Business type" formControlName="businessType" [disabled]="!employment.get('parent').value">
                        <mat-option *ngFor="let company of selfEmployedBusinessTypes" [value]="company.id">{{company.text}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-4">
                    <ng-container *ngIf="employment.get('businessType').value === 'partnership' && personList.controls.length > 1">
                      <mat-form-field appearance="outline">
                        <mat-label>Select borrower</mat-label>
                        <mat-select placeholder="Select Borrower" [disabled]="!employment.get('parent').value" formControlName="partnerships" multiple>
                          <ng-container *ngFor="let person of personList.value; index as personCnt">
                            <mat-option *ngIf="personCnt !== brwIndex" [value]="personCnt">{{person.firstName}} {{person.lastName}}</mat-option>
                          </ng-container>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                  </div>
                  <div class="col-4">
                    <mat-form-field appearance="outline" *ngIf="employment.get('businessType').value === 'partnership'">
                      <mat-label>Percentage %</mat-label>
                      <input matInput placeholder="Percentage %" type="number" formControlName="percentage">
                      <span matSuffix>%</span>
                      <mat-error>
                        <app-validation-partial [formGroup]="employment" [fieldName]="'percentage'"></app-validation-partial>
                      </mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="employment.value.partnerships && employment.value.partnerships.length > 0 &&
                    employmentFormArray.errors?.invalidPartnership === employment.value.link">Total from all partners should not exceed 100%.</mat-error>
                  </div>
                </div>
                <!-- hide income info if this is not the parent -->
                <ng-container *ngIf="employment.get('parent').value">

                  <div class="row">
                    <div class="offset-4 col-4">
                      <p><strong>Current year</strong></p>
                    </div>
                    <div class="col-4">
                      <p><strong>Previous year</strong></p>
                    </div>
                  </div>
                  <div class="row" [formGroup]="employment">
                    <div class="col-4 d-flex align-items-center">
                      <strong>Income - Net profit before tax<br> (if loss, show negative)</strong>
                    </div>
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Income amount</mat-label>
                        <input matInput placeholder="Income amount" matInputCommified formControlName="currentYearIncome" [readonly]="!employment.get('parent').value">
                        <span matPrefix>$&nbsp;</span>
                        <mat-error>
                          <app-validation-partial [formGroup]="employment" [fieldName]="'currentYearIncome'"></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Income amount</mat-label>
                        <input matInput placeholder="Income amount" matInputCommified formControlName="previousYearIncome" [readonly]="!employment.get('parent').value">
                        <span matPrefix>$&nbsp;</span>
                        <mat-error>
                          <app-validation-partial [formGroup]="employment" [fieldName]="'previousYearIncome'"></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8">
                      <strong>Allowable Addbacks</strong>
                    </div>
                    <div class="col-4 text-end">
                      <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addAddback(employment)" *ngIf="employment.get('parent').value">Add allowable addback</button>
                    </div>
                  </div>

                  <ng-container *ngIf="employment.get('allowableAddBacks')">
                    <div class="row" *ngFor="let addback of employment.get('allowableAddBacks')?.controls; let i = index;">
                      <div class="col-4" [formGroup]="addback">
                        <mat-form-field appearance="outline"
                          [ngClass]="{'col-6' : (addback.value.addbackType === 'other-company'), 'col-12': (addback.value.addbackType !== 'other-company')}"
                         >
                          <mat-label>Addback types</mat-label>
                          <mat-select placeholder="Addback types" formControlName="addbackType" [disabled]="!employment.get('parent').value">
                            <mat-option [disabled]="" *ngFor="let type of debtServiceAddbacksTypes" [value]="type.id">{{type.text}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="example-full-width col-6" *ngIf="addback.value.addbackType === 'other-company'">
                          <input matInput placeholder="Description" formControlName="addbackDescription" [readonly]="!employment.get('parent').value">
                        </mat-form-field>
                      </div>
                      <div class="col-4" [formGroup]="addback">
                        <mat-form-field appearance="outline">
                          <mat-label>Income amount</mat-label>
                          <input matInput placeholder="Income amount" matInputCommified formControlName="addbackCurrentYearIncome" [readonly]="!employment.get('parent').value">
                          <span matPrefix>$&nbsp;</span>
                          <mat-error>
                            <app-validation-partial [formGroup]="employment" [fieldName]="'addbackCurrentYearIncome'"></app-validation-partial>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-3" [formGroup]="addback">
                        <mat-form-field appearance="outline">
                          <mat-label>Income amount</mat-label>
                          <input matInput placeholder="Income amount" matInputCommified formControlName="addbackPreviousYearIncome" [readonly]="!employment.get('parent').value">
                          <span matPrefix>$&nbsp;</span>
                          <mat-error>
                            <app-validation-partial [formGroup]="employment" [fieldName]="'addbackPreviousYearIncome'"></app-validation-partial>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-1">
                        <button type="button" mat-icon-button (click)="removeAddback(employment, i)" color="warn" *ngIf="employment.get('parent').value">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div class="row" *ngIf="employment.get('allowableAddBacks').errors?.noSameValues">
                      <div class="col-12">
                        <mat-error>
                          Addback types must be unique. Max of 2 "Other" addbacks are allowed.
                        </mat-error>
                      </div>
                    </div>
                  </ng-container>

                  <div class="row" [formGroup]="employment">
                    <div class="col-4 d-flex align-items-center">
                      <strong>Total income including addbacks</strong>
                    </div>
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Total amount</mat-label>
                        <input matInput placeholder="Total amount" matInputCommified formControlName="currentYearTotalIncome" [readonly]="true">
                        <span matPrefix>$&nbsp;</span>
                      </mat-form-field>
                    </div>
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Total amount</mat-label>
                        <input matInput placeholder="Total amount" matInputCommified formControlName="previousYearTotalIncome" [readonly]="true">
                        <span matPrefix>$&nbsp;</span>
                      </mat-form-field>
                    </div>
                  </div>

                </ng-container>
              </ng-container>

              <ng-container *ngIf="!isSMSF && employment.value.requireIncomes && employment.get('status').value !== 'retired'">
                <div class="row mt-2 mb-2">
                  <div class="col-8">
                    <h5>Income Details</h5>
                  </div>
                  <div class="col-4 text-end" *ngIf="employment.get('incomes')">
                    <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addIncome(employment.get('incomes'))">Add income</button>
                  </div>
                </div>

                <ng-container *ngFor="let income of employment.get('incomes')?.controls; let i = index; let first = first;">
                  <div class="row mt-2" [formGroup]="income">
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Income type</mat-label>
                        <mat-select placeholder="Income type" formControlName="type">
                          <mat-option *ngFor="let source of salaryIncomeSourceTypes" [value]="source.id">{{source.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Select a frequency</mat-label>
                        <mat-select placeholder="Select a frequency" formControlName="frequency">
                          <mat-option *ngFor="let frequency of frequencyTypes" [value]="frequency.id">{{frequency.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{(income.get('type').value && income.get('frequency').value) ? getIncomeLabel(income, frequencyTypes, salaryIncomeSourceTypes) : 'Gross salary'}}</mat-label>
                        <input matInput placeholder="{{(income.get('type').value && income.get('frequency').value) ? getIncomeLabel(income, frequencyTypes, salaryIncomeSourceTypes) : 'Gross salary'}}" matInputCommified formControlName="amount">
                        <span matPrefix>$&nbsp;</span>
                        <mat-error>
                          <app-validation-partial [formGroup]="income" [fieldName]="'amount'"></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-1">
                      <button type="button" mat-icon-button (click)="removeIncome(employment.get('incomes'), i)" color="warn" *ngIf="!first">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </mat-card-content>
          </mat-card>
        </ng-container>

        <ng-container *ngFor="let employment of brwEmployment.get('previousEmployments')?.controls; let i = index; let first = first;">
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="row" *ngIf="first">
                <div class="col-12">
                  <h5>Previous Employment</h5>
                </div>
              </div>
              <div class="row" [formGroup]="employment">
                <div class="col-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Employer</mat-label>
                    <input matInput placeholder="Employer" formControlName="employer">
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Occupation</mat-label>
                    <input matInput placeholder="Occupation" formControlName="occupation">
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a category</mat-label>
                    <mat-select placeholder="Select a category" formControlName="category" (selectionChange)="checkEmployerValidation($event.value, employment)">
                      <mat-option *ngFor="let type of employmentCategoryVxTypes" [value]="type.id">{{type.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" [formGroup]="employment">
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a status</mat-label>
                    <mat-select placeholder="Select a status" formControlName="status" (selectionChange)="handleEmploymentStatusChange(employment, $event.value)">
                      <mat-option *ngFor="let status of employmentStatusTypes" [value]="status.id">{{status.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Basis</mat-label>
                    <mat-select placeholder="Basis" formControlName="basis">
                      <mat-option
                        [disabled]="employment.value.validBasis && !employment.value.validBasis.includes(status.id)"
                        *ngFor="let status of employmentTypes" [value]="status.id">{{status.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Tenure (years)</mat-label>
                    <input matInput placeholder="Tenure (years)" type="number" formControlName="lengthYears" (change)="togglePrevEmployer(brwEmployment.get('currentEmployments'), brwEmployment.get('previousEmployments')); toggleProbation($event.target.value, employment.get('probation'));">
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Tenure (months)</mat-label>
                    <input matInput placeholder="Tenure (months)" type="number" min="0" max="11" formControlName="lengthMonths" (change)="togglePrevEmployer(brwEmployment.get('currentEmployments'), brwEmployment.get('previousEmployments'))">
                    <mat-error>Please input a number between 0 and 11</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-2 d-flex align-items-center">
                  <mat-checkbox *ngIf="employment.value.lengthYears === 0" formControlName="probation" [value]="true"> Probation</mat-checkbox>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>

        <mat-card appearance="outlined" class="mb-4" [formGroup]="brwEmployment" *ngIf="!isSMSF">
          <mat-card-content>
            <!-- Income -->
            <div class="row">
              <div class="col-sm-8">
                <h5>Other Incomes</h5>
              </div>
              <div class="col-sm-4 text-end">
                <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addIncome(brwEmployment.get('otherIncomes'))">Add Income</button>
              </div>
            </div>
            <div class="row" *ngFor="let otherIncome of brwEmployment.get('otherIncomes')?.controls; let otherIncomeIndex = index">
              <ng-container [formGroup]="otherIncome" >
                <div class="col-sm-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Income type</mat-label>
                    <mat-select placeholder="Income type" formControlName="type">
                      <ng-container *ngIf="personList.value[brwIndex]?.nonApplicant">
                        <mat-option *ngFor="let source of nasOtherIncomeTypes" [value]="source.id">{{source.text}}</mat-option>
                      </ng-container>
                      <ng-container *ngIf="!personList.value[brwIndex]?.nonApplicant">
                        <mat-option *ngFor="let source of otherIncomeSourceTypes" [value]="source.id">{{source.text}}</mat-option>
                      </ng-container>
                    </mat-select>
                    <mat-error>
                      <app-validation-partial [formGroup]="otherIncome" [fieldName]="'type'"></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a frequency </mat-label>
                    <mat-select placeholder="Select a frequency" formControlName="frequency">
                      <mat-option *ngFor="let frequency of frequencyTypes" [value]="frequency.id">{{frequency.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field appearance="outline">
                    <mat-label>{{(otherIncome.get('type').value && otherIncome.get('frequency').value) ? getIncomeLabel(otherIncome, frequencyTypes, otherIncomeSourceTypes) : 'Amount'}}</mat-label>
                    <input matInput placeholder="{{(otherIncome.get('type').value && otherIncome.get('frequency').value) ? getIncomeLabel(otherIncome, frequencyTypes, otherIncomeSourceTypes) : 'Amount'}}" matInputCommified formControlName="amount">
                    <span matPrefix>$&nbsp;</span>
                    <mat-error>
                      <app-validation-partial [formGroup]="otherIncome" [fieldName]="'amount'"></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-1">
                  <button type="button" mat-icon-button (click)="removeIncome(brwEmployment.get('otherIncomes'), otherIncomeIndex)" color="warn" *ngIf="!first">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="mb-4" [formGroup]="brwEmployment" *ngIf="!isSMSF">
          <mat-card-content>
            <!-- Income -->
            <div class="row">
              <div class="col-sm-8">
                <h5>Non-taxable Incomes</h5>
              </div>
              <div class="col-sm-4 text-end">
                <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addIncome(brwEmployment.get('nonTaxableIncomes'))">Add Income</button>
              </div>
            </div>
            <div class="row" *ngFor="let nonTaxableIncome of brwEmployment.get('nonTaxableIncomes')?.controls; let otherIncomeIndex = index">
              <ng-container [formGroup]="nonTaxableIncome" >
                <div class="col-sm-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Income type</mat-label>
                    <mat-select placeholder="Income type" formControlName="type">
                      <mat-option *ngFor="let source of nonTaxableIncomeSourceTypes" [value]="source.id">{{source.text}}</mat-option>
                    </mat-select>
                    <mat-error>
                      <app-validation-partial [formGroup]="nonTaxableIncome" [fieldName]="'type'"></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Select a frequency</mat-label>
                    <mat-select placeholder="Select a frequency" formControlName="frequency">
                      <mat-option *ngFor="let frequency of frequencyTypes" [value]="frequency.id">{{frequency.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-sm-3">
                  <mat-form-field appearance="outline">
                    <mat-label>{{(nonTaxableIncome.get('type').value && nonTaxableIncome.get('frequency').value) ? getIncomeLabel(nonTaxableIncome, frequencyTypes, nonTaxableIncomeSourceTypes) : 'Amount'}}</mat-label>
                    <input matInput placeholder="{{(nonTaxableIncome.get('type').value && nonTaxableIncome.get('frequency').value) ? getIncomeLabel(nonTaxableIncome, frequencyTypes, nonTaxableIncomeSourceTypes) : 'Amount'}}" matInputCommified formControlName="amount">
                    <span matPrefix>$&nbsp;</span>
                    <mat-error>
                      <app-validation-partial [formGroup]="nonTaxableIncome" [fieldName]="'amount'"></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-1">
                  <button type="button" mat-icon-button (click)="removeIncome(brwEmployment.get('nonTaxableIncomes'), nonTaxableIncome)" color="warn" *ngIf="!first">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>

      </ng-container>

    </ng-container>

    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-employment-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
